export default [
  {
    path: '/employment',
    component: () => import('./Employment.vue'),
    children: [
      {
        path: 'admin',
        component: () => import('./employment-admin/EmploymentAdmin.vue'),
        name: 'employmentAdmin'
      },
      {
        path: 'import',
        component: () => import('./employment-admin/employment-import/EmploymentImport.vue'),
        name: 'employmentImport'
      },
      {
        path: 'publish',
        component: () => import('./employment-admin/employment-publish/EmploymentPublish.vue'),
        name: 'employmentPublish'
      },
      {
        path: 'employment',
        component: () => import('./settings/Employment.vue'),
        name: 'employment'
      }
    ]
  }
]
